module.exports = {
  siteTitle: "KubeCon2018Jobs",
  siteTitleShort: "KubeCon Seattle 2018 Jobs", // Short site title for homescreen (PWA). Preferably should be under 12 characters to prevent truncation.
  siteTitleAlt: "Jobs listing from the Seattle KubeCon 2018 jobs board", // Alternative site title for SEO.
  siteUrl: "https://gitumarkk.github.io/kubecon2018jobs/", // Domain of your website without pathPrefix.
  repository: "https://github.com/gitumarkk/kubecon2018jobs",
  repositoryUsername: "gitumarkk",
  repositoryUsernameUrl: "https://github.com/gitumarkk",
  pathPrefix: "/kubecon2018jobs", // Prefixes all links. For cases when deployed to example.github.io/gatsby-material-starter/.
  siteDescription: "Jobs listing from the Seattle KubeCon 2018 jobs board", // Website description used for RSS feeds/meta description tag.
  // siteRss: "/rss.xml", // Path to the RSS file.
  siteGATrackingID: "UA-131111082-1", // Tracking code ID for google analytics.
  postDefaultCategoryID: "Tech", // Default category for posts.
  dateFromFormat: "YYYY-MM-DD", // Date format used in the frontmatter.
  dateFormat: "DD/MM/YYYY", // Date format for display.
  userName: "Mark G", // Username to display in the author segment.
  userTwitter: "", // Optionally renders "Follow Me" in the UserInfo segment.
  copyright: "Copyright © 2018. Gitumarkk" // Copyright string for the footer of the website and RSS feed.
}
